import React, { useState } from "react";
import "./Change_Login_Password.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function Change_Login_Password() {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  return (
    <>
      <section className="Change_Login_Password login-page">
        <Common_white_header headingText={"Change Login Password"} />

        <div className="container">
          {/* Login  Password */}
          <div className="form-group field_holder">
            <Form.Label>
              <img
                src="/assets/images/icons/lock.png"
                alt="icon"
                className="login_lable_icons"
              />{" "}
              Login Password
            </Form.Label>

            <div className="password_input">
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Enter Login Password"
              />
              <span
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </span>
            </div>
          </div>

          {/* Set Password */}
          <div className="form-group field_holder">
            <Form.Label>
              <img
                src="/assets/images/icons/lock.png"
                alt="icon"
                className="login_lable_icons"
              />{" "}
              New Login Password
            </Form.Label>

            <div className="password_input">
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Enter New Login Password"
              />
              <span
                className="eye-icon"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEye /> : <FaEyeSlash />}
              </span>
            </div>
          </div>

          {/* Confirm New  Password */}
          <div className="form-group field_holder">
            <Form.Label>
              <img
                src="/assets/images/icons/lock.png"
                alt="icon"
                className="login_lable_icons"
              />{" "}
              Confirm New Password
            </Form.Label>

            <div className="password_input">
              <Form.Control
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Enter Confirm New Password"
              />
              <span
                className="eye-icon"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
              </span>
            </div>
          </div>

          <Link to={"/forgot-password"}>
            <div className="span_text_holder">
              <p>
                Forgot Original Login Password{" "}
                <FontAwesomeIcon icon={faChevronRight} className="ms-2" />
              </p>
            </div>
          </Link>

          <button class="btn_register_bg ">Save changes</button>
        </div>
      </section>
    </>
  );
}

export default Change_Login_Password;
